var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"app-container flex-grow-1 pa-0",attrs:{"fluid":""}},[_c('Navbar'),_c('v-main',{attrs:{"fill-height":""}},[_c('v-container',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }